module.exports = __webpack_public_path__ + "static/media/skill4_pos_en.42818339.txt";